import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type Props = {
  clientId: string;
};

export const useConnectAsset = ({ clientId }: Props) => {
  const queryClient = useQueryClient();

  const {
    mutateAsync: connectAssetMutation,
    isPending: isLoading,
    error,
    isError,
  } = useMutation<{ data: unknown }, Error, string>({
    mutationFn: (assetId: string) =>
      api.put(`clients/${clientId}/assets/${assetId}/connect-to-feed`, {}),
    // A refused connect means the feed match the banner showed has changed, so refetch either way.
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['clients', clientId] });
    },
  });

  const connectAsset = async (assetId: string) => connectAssetMutation(assetId);

  return {
    connectAsset,
    isLoading,
    error,
    isError,
  };
};
